<script setup lang="ts">
defineProps<{
    url: string | null | undefined;
    label: string;
    className?: string;
}>();
</script>

<template>
    <div
        v-if="url !== null && url !== undefined"
        class="document-container"
    >
        <a
            :href="url"
            target="_blank"
            :class="`download ${className || ''}`"
        >
            {{ label }}
        </a>
    </div>
</template>

<style scoped>
.document-container {
    padding: 0;
    margin: auto;
}

.document-container + .document-container {
    padding-top: 1rem;
}
</style>
